// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vis-cf-background-opacity-wrapper{align-items:center;margin-top:16px}.vis-cf-background-opacity-wrapper .vis-cf-background-opacity-background-value,.vis-cf-background-opacity-wrapper .vis-cf-background-opacity-background-value>input{height:32px}.vis-cf-background-opacity-background-value{border-bottom-width:2px;border-bottom-style:solid;float:right;width:80px;margin-left:auto}\n", ""]);
// Exports
module.exports = exports;
